import React from 'react';
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Button,
	Typography,
	Icon,
	IconButton,
	FormControlLabel,
	Radio,
	RadioGroup,
	TextField
} from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import { GetUserId, GetUserToken } from 'helpers/UserHelper';
import { BirthdayTemplates } from 'helpers/BirthdayTemplates';
import { uniqWith, isEqual } from 'lodash';

class Birthdays extends React.Component {
	state = {
		bdDialog: false,
		clientEmail: '',
		clientName: '',
		messageFormality: 'formal',
		language: 'eng',
		phoneNumber: '',
		message: BirthdayTemplates['formal']['eng']
	};

	handleBirthdayOpen = (email, name, phone, formality, language) => {
		this.setState({
			bdDialog: true,
			clientEmail: email,
			clientName: name,
			messageFormality: formality,
			language: language ? language.substring(0, 3) : 'eng',
			phoneNumber: phone
		});
		console.log('Email : ', email);
	};

	handleBirthdayClose = () => {
		this.setState({
			bdDialog: false,
			clientEmail: '',
			clientName: '',
			messageFormality: '',
			language: '',
			message: ''
		});
	};

	handleSendBDEmail = () => {
		const input = {
			clientId: 4,
			brokerId: GetUserId(),
			token: GetUserToken(),
			clientEmail: this.state.clientEmail,
			message: this.state.message
		};

		this.props
			.SendBirthdayWishes({
				variables: {
					input
				}
			})
			.then(resp => {
				//refetch();
				// this.showNotification("br");
				// this.setState({
				//   snackBarColor: "success",
				//   snackBarText: "Birthday Wish Sent"
				// });
				this.setState({
					bdDialog: false,
					clientEmail: '',
					clientName: '',
					messageFormality: '',
					language: '',
					message: ''
				});
			})
			.catch(error => {
				console.log('err', error);
			});
	};

	componentDidMount() {
		this.props.updatePs2();
	}

	componentDidUpdate() {
		this.props.updatePs2();
	}

	handleChangeMessageFormality = event => {
		this.setState({
			messageFormality: event.target.value,
			message: BirthdayTemplates[event.target.value][this.state.language]
		});
	};

	handleChangeLanguage = event => {
		this.setState({
			language: event.target.value,
			message:
				BirthdayTemplates[this.state.messageFormality][event.target.value]
		});
	};

	handleChangeMessage = event => {
		this.setState({
			message: event.target.value
		});
	};

	render() {
		let birthdaysToday = this.props.data.ClientByBirthday.today;
		let thisWeek = this.props.data.ClientByBirthday.week;

		let BirthdayWish = (
			<Dialog open={this.state.bdDialog} onClose={this.handleBirthdayClose}>
				<DialogTitle>{'Happy Birthday Wishes!'}</DialogTitle>
				<DialogContent>
					<div style={{ textAlign: 'center' }}>
						<p>{'Wish ' + this.state.clientName + ' a Happy Birthday!'}</p>
						<p>
							{'You can give ' +
								this.state.clientName +
								' a call at ' +
								this.state.phoneNumber}
						</p>
						<p>{'Or send them a Message or Email.'}</p>
					</div>
					<div style={{ display: 'flex' }}>
						<RadioGroup
							aria-label="Message Type"
							name="messageFormality"
							value={this.state.messageFormality}
							onChange={this.handleChangeMessageFormality}
						>
							<FormControlLabel
								value="formal"
								control={<Radio />}
								label="Formal"
							/>
							<FormControlLabel
								value="informal"
								control={<Radio />}
								label="Informal"
							/>
						</RadioGroup>
						<RadioGroup
							aria-label="Language"
							name="language"
							value={this.state.language}
							onChange={this.handleChangeLanguage}
						>
							<FormControlLabel
								value="afr"
								control={<Radio />}
								label="Afrikaans"
							/>
							<FormControlLabel
								value="eng"
								control={<Radio />}
								label="English"
							/>
						</RadioGroup>
					</div>
					<TextField
						style={{ width: '40vw' }}
						id="birthday-wish"
						label="Birthday Wish"
						multiline
						rowsMax="4"
						value={this.state.message}
						onChange={this.handleChangeMessage}
						margin="normal"
						variant="outlined"
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.handleSendBDEmail} color="secondary">
						Send Message
					</Button>
					<Button
						onClick={this.handleBirthdayClose}
						color="secondary"
						autoFocus
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		);

		return (
			<React.Fragment>
				<Typography variant="subheading" className="centerCell">
					Today
				</Typography>

				<div
					style={{
						borderBottom: '1px solid #cccccc69',
						margin: '5px auto',
						width: '25%',
						marginBottom: '20px'
					}}
				/>

				{uniqWith(birthdaysToday, isEqual).map((c, i) => {
					return (
						<GridContainer>
							<GridItem
								xs={9}
								sm={9}
								md={9}
								style={{
									position: 'relative',
									borderTop: '1px solid #eeeeee',
									borderBottom: '1px solid #eeeeee'
								}}
								className={i % 2 === 0 ? '' : 'disabledRow'}
							>
								<Typography
									style={{
										position: 'absolute',
										top: '25%',
										paddingLeft: '15px'
									}}
								>
									{c.scd_nickName
										? c.scd_nickName
										: c.scd_name
										? c.scd_name
										: ''}
									{` ${c.scd_surname} `}
									{'(' + c.scd_dateOfBirth.age + ')'}
								</Typography>
							</GridItem>
							<GridItem
								xs={3}
								sm={3}
								md={3}
								className={i % 2 === 0 ? '' : 'disabledRow'}
								style={{
									position: 'relative',
									borderTop: '1px solid #eeeeee',
									borderBottom: '1px solid #eeeeee'
								}}
							>
								<IconButton
									color="secondary"
									onClick={() =>
										this.handleBirthdayOpen(
											c.scd_email,
											c.scd_name,
											c.scd_phoneNumber,
											c.scd_correspondenceFormality,
											c.scd_correspondenceLanguage
										)
									}
								>
									<Icon>mail_outline</Icon>
								</IconButton>
							</GridItem>
						</GridContainer>
					);
				})}

				{birthdaysToday.length < 1 ? (
					<Typography variant="caption" style={{ textAlign: 'center' }}>
						No Birthdays Today
					</Typography>
				) : null}

				<Typography
					variant="subheading"
					className="centerCell"
					style={{
						marginTop: '24px'
					}}
				>
					This Coming Week
				</Typography>

				<div
					style={{
						borderBottom: '1px solid #cccccc69',
						margin: '5px auto',
						width: '25%',
						marginBottom: '20px'
					}}
				/>

				{uniqWith(thisWeek, isEqual).map((c, i) => {
					let birthdayDate = '';
					if (c.scd_dateOfBirth.basicDate.includes('-')) {
						const splitDate = c.scd_dateOfBirth.basicDate.split('-');
						birthdayDate = `${splitDate[2]}/${splitDate[1]}`;
					} else if (c.scd_dateOfBirth.basicDate.includes('/')) {
						const splitDate = c.scd_dateOfBirth.basicDate.split('/');
						birthdayDate = `${splitDate[1]}/${splitDate[0]}`;
					}

					return (
						<GridContainer style={{ marginBottom: '15px' }}>
							<GridItem
								xs={7}
								sm={7}
								md={9}
								style={{
									borderTop: '1px solid #eeeeee',
									borderBottom: '1px solid #eeeeee'
								}}
								className={i % 2 === 0 ? '' : 'disabledRow'}
							>
								<Typography
									style={{
										padding: '15px'
									}}
								>
									{c.scd_nickName
										? c.scd_nickName
										: c.scd_name
										? c.scd_name
										: ''}
									{` ${c.scd_surname} `}
									{'(' + c.scd_dateOfBirth.age + ')'}
								</Typography>
							</GridItem>
							<GridItem
								xs={5}
								sm={5}
								md={3}
								className={i % 2 === 0 ? '' : 'disabledRow'}
								style={{
									borderTop: '1px solid #eeeeee',
									borderBottom: '1px solid #eeeeee'
								}}
							>
								<Typography
									style={{
										padding: '15px'
									}}
								>
									{birthdayDate}
								</Typography>
							</GridItem>
						</GridContainer>
					);
				})}

				{thisWeek.length < 1 ? (
					<Typography variant="caption" style={{ textAlign: 'center' }}>
						No Birthdays This Coming Week
					</Typography>
				) : null}

				{this.state.bdDialog && BirthdayWish}
			</React.Fragment>
		);
	}
}

export default Birthdays;



// WEBPACK FOOTER //
// ./src/views/Dashboard/components/Birthdays.jsx